import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Packages
import { Helmet } from 'react-helmet';

class OnboardingSuccess extends Component {

  render() {
    const { appName } = this.props;

    return (
      <div>
        <Helmet>
          <title>{appName} | Success!</title>
        </Helmet>
        <header>
          <h2>
            Success!
          </h2>
          <h3>
            You've completed your Locker Linked account.
          </h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac consectetur ac.
          </p>
        </header>
        <Link to="/" className="cta invert full-width">
          Continue to Dashboard
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
  }
}

export default connect(
  mapStateToProps,
  null
)(OnboardingSuccess)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/OnboardingSuccess.js